export default "__VITE_ASSET__DlayvGg8__"